import { Component, OnInit } from '@angular/core';
import { PrinterService } from '../services';
import { SerialPrinterService } from './printer.service';

@Component({
  selector: 'app-printer',
  templateUrl: './printer.component.html',
  styleUrls: ['./printer.component.scss']
})
export class PrinterComponent implements OnInit {

  printerState = 'not updated';

  constructor(private printerService: PrinterService, private printer: SerialPrinterService) { }

  ngOnInit() {
    this.getState();
  }

  findPrinter() {
    this.printerService.findPrinter().subscribe(
      (data) => {
        this.printerState = data;
      },
      (err) => {},
      () => {}
    );
  }

  getState() {
    this.printer.getState().subscribe({
      next: (data) => {
        this.printerState = data;
      },
      error: (err) => {},
      complete: () => {}
    });
  }

}
